module.exports = __webpack_public_path__ + "fonts/xjAJXh38I15wypJXxuGMBgt_Rm691LTebKfY2ZkKSmI.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/xjAJXh38I15wypJXxuGMBgt_Rm691LTebKfY2ZkKSmI.woff2
// module id = 409
// module chunks = 0